const translations = {
  appName: 'SILY-OBC',
  dashboard: 'Tableau de Bord',
  trucks: 'Camions',
  tasks: 'Tâches',
  profile: 'Profil',
  login: 'Connexion',
  register: 'Inscription',
  logout: 'Déconnexion',
  search: 'Rechercher',
  filter: 'Filtrer',
  all: 'Tous',
  status: 'Statut',
  good: 'Bon',
  broken: 'En panne',
  waiting: 'En attente',
  inProgress: 'En cours',
  done: 'Terminé',
  repaired: 'Réparé',
  ok: 'OK',
  // Problem types dropdown
  selectProblem: 'Sélectionner un problème...',
  noProblem: 'Aucun problème',
  doorNumber: 'N° Portière',
  licensePlate: 'N° Immatriculation',
  generalStatus: 'État Général',
  reportedProblem: 'Problème Signalé',
  breakdownDate: 'Date de Panne',
  repairsDone: 'Réparations Effectuées',
  repairStatus: 'Statut de Réparation',
  comments: 'Commentaires',
  driver: 'Chauffeur',
  contact: 'Contact',
  totalTrucks: 'Total Camions',
  brokenTrucks: 'Camions en Panne',
  goodTrucks: 'Camions en Bon État',
  repairedTrucks: 'Camions Réparés',
  addTask: 'Nouvelle Tâche',
  taskTitle: 'Titre',
  taskDescription: 'Description',
  assignedTo: 'Assigné à',
  priority: 'Priorité',
  dueDate: 'Date d\'échéance',
  low: 'Basse',
  medium: 'Moyenne',
  high: 'Haute',
  todo: 'À faire',
  save: 'Enregistrer',
  cancel: 'Annuler',
  edit: 'Modifier',
  delete: 'Supprimer',
  send: 'Envoyer',
  newComment: 'Nouveau commentaire',
  noComments: 'Aucun commentaire',
  noTasks: 'Aucune tâche',
  truckDetails: 'Détail du Camion',
  backToDashboard: 'Retour au tableau de bord',
  email: 'Email',
  password: 'Mot de passe',
  fullName: 'Nom complet',
  confirmPassword: 'Confirmer le mot de passe',
  enterPasswordToConfirm: 'Saisissez votre mot de passe pour confirmer cette action.',
  invalidPassword: 'Mot de passe incorrect.',
  confirm: 'Confirmer',
  noAccount: 'Pas encore de compte ?',
  haveAccount: 'Déjà un compte ?',
  createAccount: 'Créer un compte',
  signIn: 'Se connecter',
  welcome: 'Bienvenue',
  role: 'Rôle',
  admin: 'Administrateur',
  technicien: 'Technicien',
  chauffeur: 'Chauffeur',
  technician: 'Technicien',
  myTasks: 'Mes Tâches',
  allTasks: 'Toutes les Tâches',
  overdue: 'En retard',
  today: 'Aujourd\'hui',
  thisWeek: 'Cette semaine',
  sortBy: 'Trier par',
  date: 'Date',
  name: 'Nom',
  actions: 'Actions',
  view: 'Voir',
  close: 'Fermer',
  problemTypes: 'Types de Problèmes',
  cameraDSMDecollee: 'Caméra DSM Décollée',
  cameraADASDecollee: 'Caméra ADAS Décollée',
  cameraDSMMalReglee: 'Caméra DSM Mal Réglée',
  cameraADASMalReglee: 'Caméra ADAS Mal Réglée',
  cameraFloue: 'Caméra Floue',
  extractionImpossible: 'Extraction Vidéo Impossible',
  pasCommunication: 'Pas de Comm. avec Serveur',
  perteSignalGPS: 'Perte de Signal GPS Prolongé',
  videoDSMPerdue: 'Vidéo DSM Perdue',
  videoADASPerdue: 'Vidéo ADAS Perdue',
  buzzerSonneArret: 'Buzzer Sonne en Étant Arrêté',
  buzzer30kmh: 'Buzzer Sonne -30km/h',
  buzzer40kmh: 'Buzzer Sonne -40km/h',
  buzzer60kmh: 'Buzzer Sonne -60km/h',
  buzzerNeSonnePas: 'Buzzer Ne Sonne Pas',
  createdAt: 'Créé le',
  updatedAt: 'Mis à jour le',
  by: 'par',
  noResults: 'Aucun résultat',
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  // Export
  export: 'Exporter',
  exportPDF: 'Exporter en PDF',
  exportExcel: 'Exporter en Excel',
  exportDatabase: 'Sauvegarder (JSON)',
  importExport: 'Import / Export',
  importTrucks: 'Importer des camions',
  importDrivers: 'Importer des chauffeurs',
  restoreDatabase: 'Restaurer (JSON)',
  exportTrucksXLSX: 'Exporter Camions (Excel)',
  exportDriversXLSX: 'Exporter Chauffeurs (Excel)',
  exportTasksXLSX: 'Exporter Tâches (Excel)',
  importSuccess: 'Import réussi',
  importError: 'Erreur d\'import',
  // Truck detail
  truckNotFound: 'Camion non trouvé',
  selectTruck: 'Sélectionner un camion...',
  select: 'Sélectionner...',
  noData: 'Aucune donnée',
  // Export reports
  exportTrucksReport: 'Rapport Camions',
  exportTasksReport: 'Rapport Tâches',
  // Auth errors
  passwordsDontMatch: 'Les mots de passe ne correspondent pas',
  // Pagination
  page: 'Page',
  previous: 'Précédent',
  next: 'Suivant',
  of: 'sur',
  // Drivers
  drivers: 'Chauffeurs',
  addTruck: 'Ajouter un camion',
  addDriver: 'Ajouter un chauffeur',
  selectDriver: 'Sélectionner un chauffeur',
  manageTrucks: 'Camions',
  manageDrivers: 'Chauffeurs',
  driverName: 'Nom du chauffeur',
  driverContact: 'Contact',
  driverExists: 'Ce chauffeur existe déjà',
  noDrivers: 'Aucun chauffeur enregistré',
  deleteDriver: 'Supprimer',
  editDriver: 'Modifier le chauffeur',
  updateDriver: 'Mettre à jour',
  // Truck management
  truckAdded: 'Camion ajouté avec succès',
  driverAdded: 'Chauffeur ajouté avec succès',
  driverDeleted: 'Chauffeur supprimé',
  driverUpdated: 'Chauffeur mis à jour',
  truckList: 'Liste des camions',
  addNewTruck: 'Nouveau camion',
  addNewDriver: 'Nouveau chauffeur',
  searchDoorNumber: 'N° portière (ex: 01, 10, 20...)',
  doubleClickToEdit: 'Double-cliquez pour modifier',
  invalidCredentials: 'Email ou mot de passe incorrect.',
  // Notifications
  notifications: 'Notifications',
  noNotifications: 'Aucune notification',
  markAllRead: 'Tout marquer comme lu',
  moreNotifications: 'de plus',
  notifTaskCreated: 'Tâche créée',
  notifNewTask: 'Nouvelle tâche créée',
  notifStatusChanged: 'Statut modifié',
  notifTaskStatusChanged: 'Tâche',
  notifTo: 'passée à',
  notifTaskDeleted: 'Tâche supprimée',
  notifTaskDeletedMsg: 'Tâche supprimée',
  deleteComment: 'Supprimer le commentaire',
  // Server connection
  connectingToServer: 'Connexion au serveur...',
  serverConnectionError: 'Impossible de se connecter au serveur. Vérifiez que l\'application est bien lancée (npm run dev ou npm start), puis réessayez.',
  retry: 'Réessayer',
  // 404
  pageNotFound: 'Page introuvable',
  pageNotFoundDesc: 'Cette page n\'existe pas ou a été déplacée.',
  backHome: 'Retour à l\'accueil',
  // Danger zone
  resetDatabase: 'Réinitialiser la base de données',
  deleteTruck: 'Supprimer ce camion',
  confirmDeleteTruck: 'Supprimer définitivement ce camion (et les tâches/commentaires liés) ?',
  // Profile
  myProfile: 'Mon profil',
  profileInfo: 'Informations du compte',
  currentPassword: 'Mot de passe actuel',
  newPassword: 'Nouveau mot de passe',
  confirmNewPassword: 'Confirmer le nouveau mot de passe',
  newPasswordOptional: 'Laissez vide pour conserver le mot de passe actuel',
  saveChanges: 'Enregistrer les modifications',
  profileUpdated: 'Profil mis à jour avec succès.',
  currentPasswordRequired: 'Le mot de passe actuel est requis pour confirmer les modifications.',
};

export default translations;